/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

export type BTAdminBuilderPreference =
  (typeof BTAdminBuilderPreference)[keyof typeof BTAdminBuilderPreference];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BTAdminBuilderPreference = {
  notificationHistoryRedesign: "notificationHistoryRedesign",
  taskManagementOptIn: "taskManagementOptIn",
  selectionOptionDocumentScraping: "selectionOptionDocumentScraping",
  jcbViewDropdown: "jcbViewDropdown",
  rNStandaloneFilePicker: "rNStandaloneFilePicker",
  subsAuth0Migration: "subsAuth0Migration",
  allowanceDetailsPanel: "allowanceDetailsPanel",
  permissionsMfaEnrollmentCohort: "permissionsMfaEnrollmentCohort",
  rFIOwnersV1: "rFIOwnersV1",
  bdsContentHeaderListPageReplacement: "bdsContentHeaderListPageReplacement",
  worksheetAGGrid: "worksheetAGGrid",
  estimateMobileServices: "estimateMobileServices",
  sageARPayments: "sageARPayments",
  sageSync: "sageSync",
  paymentMethodUI: "paymentMethodUI",
  tasksGeneralJob: "tasksGeneralJob",
  vendorCreditAndBillPaymentForAccounting:
    "vendorCreditAndBillPaymentForAccounting",
  billsFullPageConversion: "billsFullPageConversion",
  changeOrdersNewItemHeader: "changeOrdersNewItemHeader",
  bdsContentHeaderIndividualReplacements:
    "bdsContentHeaderIndividualReplacements",
  budgetCostCodeCaching: "budgetCostCodeCaching",
  bulkExport: "bulkExport",
  sageIntacctMVP: "sageIntacctMVP",
  taskDependencies: "taskDependencies",
  scanAllBillAttachments: "scanAllBillAttachments",
  editBillPercentage: "editBillPercentage",
  inFlightWorkflowEdits: "inFlightWorkflowEdits",
  timeClockLegacyGeneralJobCleanup: "timeClockLegacyGeneralJobCleanup",
  markupCostCodeRollup: "markupCostCodeRollup",
  billLineItemContainer: "billLineItemContainer",
  useNotificationsEmail: "useNotificationsEmail",
  selfServiceMfaManagement: "selfServiceMfaManagement",
  mobileOwnerInvoiceLineItems: "mobileOwnerInvoiceLineItems",
  changeOrderGroupSubgroups: "changeOrderGroupSubgroups",
  plansViewerReducedTileSize: "plansViewerReducedTileSize",
  taskGantt: "taskGantt",
  scopeOfWorkMobileCardView: "scopeOfWorkMobileCardView",
  bdsContentHeaderModalReplacement: "bdsContentHeaderModalReplacement",
  tasksCustomFieldSortTweaks: "tasksCustomFieldSortTweaks",
  allocateBillCostsAcrossMultipleJobs: "allocateBillCostsAcrossMultipleJobs",
  customForwardEmailAlias: "customForwardEmailAlias",
  selectionsReimagined: "selectionsReimagined",
  aIASignatureWorkflow: "aIASignatureWorkflow",
  sageInvoice: "sageInvoice",
  timeClockShiftDetailsHistory: "timeClockShiftDetailsHistory",
  progressInvoiceRevisedBudgetColumn: "progressInvoiceRevisedBudgetColumn",
  xeroReconnectAfterError: "xeroReconnectAfterError",
  aiaPurchaseOrder: "aiaPurchaseOrder",
  financialEntityNumbering: "financialEntityNumbering",
  disableToDos: "disableToDos",
  useRemoteEmailClassification: "useRemoteEmailClassification",
  billLineItemContainerDesktop: "billLineItemContainerDesktop",
  lowesInCompanySettings: "lowesInCompanySettings",
  deferBillsPermissionCalls: "deferBillsPermissionCalls",
  trackAllowanceProgress: "trackAllowanceProgress",
  mobileInAppFeedback: "mobileInAppFeedback",
  watchingForTasks: "watchingForTasks",
  billAccountingSyncMoment: "billAccountingSyncMoment",
  defaultSubToMailedChecks: "defaultSubToMailedChecks",
  invoiceCreationAlignment: "invoiceCreationAlignment",
  improvedSubLienWaivers: "improvedSubLienWaivers",
  requireStepUpAuthForOutboundPayments: "requireStepUpAuthForOutboundPayments",
  schedulePagedGanttPrint: "schedulePagedGanttPrint",
  selectionsAICostCodeMatching: "selectionsAICostCodeMatching",
  lienWaiverTemplateUpdates: "lienWaiverTemplateUpdates",
  progressInvoiceRetainageIndicator: "progressInvoiceRetainageIndicator",
  taxesChangeOrders: "taxesChangeOrders",
  estimateActivityLog: "estimateActivityLog",
  billPaymentScheduling: "billPaymentScheduling",
  unconditionalLienWaivers: "unconditionalLienWaivers",
  bulkRoleManagement: "bulkRoleManagement",
  apBillRetainage: "apBillRetainage",
  mobileWebviewExperience: "mobileWebviewExperience",
  jcbViewTabs: "jcbViewTabs",
  vendorCreditRelease1: "vendorCreditRelease1",
  paymentsControllerRefactor: "paymentsControllerRefactor",
  bluebeamIntegration: "bluebeamIntegration",
  enableNutrientPhotoDraw: "enableNutrientPhotoDraw",
  vendorCreditOfflinePartialPayments: "vendorCreditOfflinePartialPayments",
  nutrientLienWaiverSigning: "nutrientLienWaiverSigning",
  sharePaymentScheduleOnAllFixedPriceJobs:
    "sharePaymentScheduleOnAllFixedPriceJobs",
  combinedSubSmsNotifications: "combinedSubSmsNotifications",
  newItemHeaderDefaultJobPermissions: "newItemHeaderDefaultJobPermissions",
  paymentScheduleAfterSendToBudget: "paymentScheduleAfterSendToBudget",
  costInboxMigration: "costInboxMigration",
  disableSubOwnerExternalEmails: "disableSubOwnerExternalEmails",
  timeClockBillRate: "timeClockBillRate",
  wipReportSnapshotting: "wipReportSnapshotting",
  selectionsInvoicingWizard: "selectionsInvoicingWizard",
  taskPhaseDemo: "taskPhaseDemo",
  qbdWebConnectorHangfireDefer: "qbdWebConnectorHangfireDefer",
  globalSpecCatalog: "globalSpecCatalog",
  billsAgGridMigration: "billsAgGridMigration",
  aIPreliminaryEstimate: "aIPreliminaryEstimate",
  selectionOptionsLineItemCard: "selectionOptionsLineItemCard",
  specPublishPushNotifications: "specPublishPushNotifications",
  enableSpecPublishNotifications: "enableSpecPublishNotifications",
  genericLinkingSpecsToCO: "genericLinkingSpecsToCO",
  specsDeprecateListView: "specsDeprecateListView",
  specsCarryForwardToBidPackage: "specsCarryForwardToBidPackage",
  linkPlansToSubmittals: "linkPlansToSubmittals",
  quickBooksMigrationInvoices: "quickBooksMigrationInvoices",
  plansMultiDocRevisions: "plansMultiDocRevisions",
  messagesAllowMobileVideoUploads: "messagesAllowMobileVideoUploads",
  jpsFinancialOverviewRevamp: "jpsFinancialOverviewRevamp",
  billsAccountingExport: "billsAccountingExport",
  plansNotifications: "plansNotifications",
  selectionsInvoicingWizardLineItems: "selectionsInvoicingWizardLineItems",
  estimateWorksheetPanelView: "estimateWorksheetPanelView",
  taxesSelectionChoices: "taxesSelectionChoices",
  globalSpecCostGroupLinking: "globalSpecCostGroupLinking",
  dailyLogsAutoSave: "dailyLogsAutoSave",
  plansAiVersionSummary: "plansAiVersionSummary",
  jpsAllowances: "jpsAllowances",
  splitBillsPOsBudgetSettings: "splitBillsPOsBudgetSettings",
  mobileDirectoryAddExperience: "mobileDirectoryAddExperience",
  newItemHeaderJobDetails: "newItemHeaderJobDetails",
  defaultSpcOn: "defaultSpcOn",
  aiPoweredSearch: "aiPoweredSearch",
  jcbFind: "jcbFind",
  warrantiesModalConversion: "warrantiesModalConversion",
} as const;
